import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_input_password = _resolveComponent("a-input-password");
  const _component_a_radio_button = _resolveComponent("a-radio-button");
  const _component_a_radio_group = _resolveComponent("a-radio-group");
  const _component_a_switch = _resolveComponent("a-switch");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[9] || (_cache[9] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, null, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "基本信息"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24,
              style: {
                "padding-top": "30px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fUserName",
                  label: "账号",
                  rules: [{
                    required: true,
                    message: '请输入登录账号!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fUserName,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.fUserName = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fPassWord",
                  label: "密码"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_password, {
                    value: $setup.DMConfig.Model.fPassWord,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model.fPassWord = $event),
                    placeholder: "登录密码"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fAdminType",
                  label: "权限类型",
                  rules: [{
                    required: true,
                    message: '请选择权限类型!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                    value: $setup.DMConfig.Model.fAdminType,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.DMConfig.Model.fAdminType = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_radio_button, {
                      value: "0"
                    }, {
                      default: _withCtx(() => [_createTextVNode("客户")]),
                      _: 1
                    }), _createVNode(_component_a_radio_button, {
                      value: "1"
                    }, {
                      default: _withCtx(() => [_createTextVNode("管理员")]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fRealName",
                  label: "K3用户账号"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fRealName,
                    "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.DMConfig.Model.fRealName = $event),
                    disabled: $setup.DMConfig.Model.fAdminType == 0,
                    allowClear: "true"
                  }, null, 8, ["value", "disabled"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "K3客户代码"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fCustNumber,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.DMConfig.Model.fCustNumber = $event),
                    disabled: $setup.DMConfig.Model.fAdminType == 1,
                    allowClear: "true"
                  }, null, 8, ["value", "disabled"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fEmail",
                  label: "电子邮箱",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fEmail,
                    "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.DMConfig.Model.fEmail = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fIsPINotice",
                  label: "是否接收PI通知"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_switch, {
                    checked: $setup.DMConfig.Model.fIsPINotice,
                    "onUpdate:checked": _cache[6] || (_cache[6] = $event => $setup.DMConfig.Model.fIsPINotice = $event)
                  }, null, 8, ["checked"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fIsInfoNotice",
                  label: "是否接收协议到期通知"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_switch, {
                    checked: $setup.DMConfig.Model.fIsInfoNotice,
                    "onUpdate:checked": _cache[7] || (_cache[7] = $event => $setup.DMConfig.Model.fIsInfoNotice = $event)
                  }, null, 8, ["checked"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 20,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fIsForbidden",
                  label: "是否启用"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_switch, {
                    checked: $setup.DMConfig.Model.fIsForbidden,
                    "onUpdate:checked": _cache[8] || (_cache[8] = $event => $setup.DMConfig.Model.fIsForbidden = $event)
                  }, null, 8, ["checked"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "onOk"]);
}